<div class="career-statistics">
<h2>{{'career_statistics' | transloco}}</h2>
<lib-filters-component [filters_options]="filterInfo" ></lib-filters-component>
<app-wa-table *ngIf="(tableData |async) as data" [showNoResultsMessage]="'No data available'" (subHeaderClick)="subHeaderAction($event)" [isSortableFunc]="sortClass" [showCondition]="true" [headers]="headers" [isDataLoading]="loading"
  [areMoreData]="areMoreData()" (loadMore)="loadMore()" [data]="data" (headerClick)="changeSort($event)">
  <ng-template [extraClass]="['visibility--hide-desktop', 'color-group-record']" app-row-group let-stats>
    <div class="">
      <div style="margin-left:10px" class="uppertext-black inline year-identificator">
        {{ stats.Year }}
      </div>
    </div>
  </ng-template>
  <ng-template [extraClass]="['wa-table__cell--fit-right', 'center-text']" app-column let-stats>
    <p class="uppertext  year-identificator">{{stats.Year}}</p>
</ng-template>
<ng-template [extraClass]="['wa-table__cell--fit-right', 'center-text']" app-column let-stats>
  <div *ngIf="stats.AverageArr != null; else zero" [ngClass]="{'uppertext-black':isMaxValue(data, 'avg') === stats.AverageArr, 'uppertext':isMaxValue(data, 'avg') !== stats.AverageArr}">
    {{stats.AverageArr.toFixed(2)}}</div>
  <ng-template #zero>
      <div class="uppertext">-</div>
    </ng-template>
</ng-template>
<ng-template [extraClass]="['wa-table__cell--fit-right', 'hoverable', 'center-text']" app-column let-stats>

   <ng-container *ngIf="stats.index===data.length-1;else yearData">
    <div *ngIf="stats.MatchTot != 0 && stats.MatchTot !=null;else zero" class="uppertext">
    <div   >{{stats.MatchWinPercentage.toFixed(0)}}%</div>
    <div  >{{stats.MatchWin}} - {{stats.MatchTot - stats.MatchWin}}</div>
    <ng-template #zero>
      <div>-</div>
    </ng-template>
  </div>
   </ng-container>
   <ng-template #yearData>  <div [ngClass]="{'uppertext-black':isMaxValue(data, 'match') === stats.MatchWinPercentage, 'uppertext':isMaxValue(data, 'match') !== stats.MatchWinPercentage}" isHovered
    *ngIf="matchesView==='Matches-W-L'; else percent"
   >
    <ng-container *ngIf="stats.MatchTot != 0 && stats.MatchTot !=null && stats.index !== data.length-1; else zero">
      <div  (mouseenter)="isHoverMatch($event, stats)" *ngIf="stats.index != isHoveredMatch" >{{stats.MatchWin}} - {{stats.MatchTot - stats.MatchWin}}</div>
      <div   (mouseleave)="isNotHoverMatch($event, stats)" *ngIf="isHoveredMatch == stats.index" >{{stats.MatchWinPercentage.toFixed(0)}} %</div>
    </ng-container>
    <ng-template  #zero>
      <div>-</div>
    </ng-template></div>
    <ng-template #percent>
      <ng-container  *ngIf="stats.MatchTot != 0 && stats.MatchTot !=null; else zero">


      <div [ngClass]="{'uppertext-black':isMaxValue(data, 'match') === stats.MatchWinPercentage, 'uppertext':isMaxValue(data, 'match') !== stats.MatchWinPercentage}" isHovered>
        <div (mouseleave)="isNotHoverMatch($event, stats)" *ngIf="isHoveredMatch == stats.index" >{{stats.MatchWin}} - {{stats.MatchTot - stats.MatchWin}}</div>
          <div  (mouseenter)="isHoverMatch($event, stats)" *ngIf="stats.index != isHoveredMatch" >{{stats.MatchWinPercentage.toFixed(0)}} %</div>
      </div>
      </ng-container>
      <ng-template  #zero>
        <div>-</div>
      </ng-template>
    </ng-template>
   </ng-template>


</ng-template>

<ng-template  [extraClass]="['wa-table__cell--fit-right', 'hoverable', 'center-text']" app-column let-stats>
  <ng-container *ngIf="data.length-1 === stats.index;else yearData">
    <div *ngIf="stats.TBTot != null && stats.TBWin != null &&  stats.TBWinPercentage != null && stats.TBTot != 0;else zero"  class="uppertext">

    <div>{{stats.TBWinPercentage.toFixed(0)}}%</div>
    <div >{{stats.TBWin}} - {{stats.TBTot - stats.TBWin}}</div>

    </div>
    <ng-template #zero>
      <div>-</div>
    </ng-template>
  </ng-container>

  <ng-template #yearData>
      <div [ngClass]="{'uppertext-black':isMaxValue(data, 'tier') === stats.TBWinPercentage, 'uppertext':isMaxValue(data, 'tier') !== stats.TBWinPercentage}"  *ngIf="tierView==='Tiebreaks-W-L'; else percentData">

    <div isHovered *ngIf="stats.TBTot != null && stats.TBWin != null &&  stats.TBWinPercentage != null && stats.TBTot != 0;else zero">
      <div  (mouseenter)="isHoverTier($event, stats)" *ngIf="stats.index != isHoveredTier">{{stats.TBWin}} - {{stats.TBTot - stats.TBWin}}</div>

      <div  (mouseleave)="isNotHoverTier($event, stats)" *ngIf="stats.index == isHoveredTier">{{stats.TBWinPercentage.toFixed(0)}} %</div>
  </div>
  <ng-template #zero>
    <div [ngClass]="{'uppertext-black':isMaxValue(data, 'tier') === stats.TBWinPercentage, 'uppertext':isMaxValue(data, 'tier') !== stats.TBWinPercentage}" isHovered >
      <div  (mouseenter)="isHoverTier($event, stats)" *ngIf="stats.index != isHoveredTier" >-</div>
      <div  (mouseleave)="isNotHoverTier($event, stats)" *ngIf="stats.index == isHoveredTier" >-</div>
    </div>
    </ng-template>
  </div>

  <ng-template #percentData>
      <div [ngClass]="{'uppertext-black':isMaxValue(data, 'tier') === stats.TBWinPercentage, 'uppertext':isMaxValue(data, 'tier') !== stats.TBWinPercentage}" isHovered *ngIf="stats.TBTot != null && stats.TBWin != null &&  stats.TBWinPercentage != null;else zero">
          <div  (mouseleave)="isNotHoverTier($event, stats)" *ngIf="stats.index == isHoveredTier">{{stats.TBWin}} - {{stats.TBTot - stats.TBWin}}</div>

          <div (mouseenter)="isHoverTier($event, stats)" *ngIf="stats.index != isHoveredTier">{{stats.TBWinPercentage.toFixed(0)}} %</div>
      </div>
      <ng-template #zero>
        <div [ngClass]="{'uppertext-black':isMaxValue(data, 'tier') === stats.TBWinPercentage, 'uppertext':isMaxValue(data, 'tier') !== stats.TBWinPercentage}" isHovered>
          <div  (mouseleave)="isNotHoverTier($event, stats)" *ngIf="stats.index == isHoveredTier" >-</div>

          <div (mouseenter)="isHoverTier($event, stats)" *ngIf="stats.index != isHoveredTier">-</div>
        </div>
        </ng-template>
  </ng-template>
  </ng-template>

</ng-template>
<ng-template  [extraClass]="['wa-table__cell--fit-right', 'center-text']" app-column let-stats>
  <div [ngClass]="{'uppertext-black':isMaxValue(data, 'qbest') === stats.QBest,
  'uppertext':isMaxValue(data, 'qbest') !== stats.QBest}" *ngIf="stats.QBest != null; else zero" class="uppertext-black center-text">
    {{' '}}{{stats.QBest}}
  </div>
  <ng-template #zero>
    <div class="uppertext" >-</div>
  </ng-template>
</ng-template>

<ng-template app-column-responsive  let-stats>
  <div class="uppertext-no-viewport">{{'Average_Arrow' | transloco}}        <p *ngIf="stats.AverageArr != null; else zero" [ngClass]="{'uppertext-black':isMaxValue(data, 'avg') === stats.AverageArr, 'uppertext':isMaxValue(data, 'avg') !== stats.AverageArr}">{{stats.AverageArr.toFixed(2)}}</p>
    <ng-template #zero>
        <div class="uppertext">-</div>
      </ng-template> </div>
      <div class="uppertext-no-viewport">
        {{'Tiebreaks' | transloco}}
        <ng-container *ngIf="stats.index === data.length-1;else yearData">
          <div class="uppertext-black" *ngIf="stats.TBTot != undefined && stats.TBTot != 0;else zero">
          <p >{{stats.TBWinPercentage.toFixed(0)}}%</p>

          <p >{{stats.TBWin}} - {{stats.TBTot - stats.TBWin}}</p>
        </div>
        <ng-template #zero>
          <div>-</div>
        </ng-template>
        </ng-container>
        <ng-template #yearData>
          <div [ngClass]="{'uppertext-black':isMaxValue(data, 'tier') === stats.TBWinPercentage, 'uppertext':isMaxValue(data, 'tier') !== stats.TBWinPercentage}"  *ngIf="tierView==='Tiebreaks-W-L'; else percent">
            <div isHovered *ngIf="stats.TBTot != undefined && stats.TBTot != 0;else zero">
                <p  (mouseenter)="isHoverTier($event, stats)" *ngIf="stats.index != isHoveredTier">{{stats.TBWin}} - {{stats.TBTot - stats.TBWin}}</p>

                <p  (mouseleave)="isNotHoverTier($event, stats)" *ngIf="stats.index == isHoveredTier">{{stats.TBWinPercentage.toFixed(0)}} %</p>
            </div>
            <ng-template #zero>
              <p  (mouseenter)="isHoverTier($event, stats)" *ngIf="stats.index != isHoveredTier" >-</p>
              <p  (mouseleave)="isNotHoverTier($event, stats)" *ngIf="stats.index == isHoveredTier" >-</p>
              </ng-template>
            </div>
            <ng-template #percent>
                <div [ngClass]="{'uppertext-black':isMaxValue(data, 'tier') === stats.TBWinPercentage, 'uppertext':isMaxValue(data, 'tier') !== stats.TBWinPercentage}" isHovered *ngIf="stats.TBTot != undefined && stats.TBTot != 0;else zero" >
                    <p  (mouseleave)="isNotHoverTier($event, stats)" *ngIf="stats.index == isHoveredTier">{{stats.TBWin}} - {{stats.TBTot - stats.TBWin}}</p>

                    <p (mouseenter)="isHoverTier($event, stats)" *ngIf="stats.index != isHoveredTier">{{stats.TBWinPercentage.toFixed(0)}} %</p>
                </div>
                <ng-template #zero>
                  <p  (mouseleave)="isNotHoverTier($event, stats)" *ngIf="stats.index == isHoveredTier" >-</p>

                  <p (mouseenter)="isHoverTier($event, stats)" *ngIf="stats.index != isHoveredTier">-</p>
                  </ng-template>
            </ng-template>
        </ng-template>

      </div>
    </ng-template>
<ng-template app-column-responsive  let-stats>

     <div class="uppertext-no-viewport" >
        {{'Matches' | transloco}}
        <ng-container *ngIf="stats.MatchTot != 0 && stats.MatchTot !=null; else zero">
          <ng-container *ngIf="stats.index === data.length-1;else yearData">
            <div class="uppertext-black">
            <p  class="uppertext-black" >{{stats.MatchWinPercentage.toFixed(0)}}%</p>

            <p >{{stats.MatchWin}} - {{stats.MatchTot - stats.MatchWin}}</p>
          </div>
          </ng-container>
          <ng-template #yearData>
            <div [ngClass]="{'uppertext-black':isMaxValue(data, 'match') === stats.MatchWinPercentage, 'uppertext':isMaxValue(data, 'match') !== stats.MatchWinPercentage}" isHovered *ngIf="matchesView==='Matches-W-L'; else percent"
            >
           <p  (mouseenter)="isHoverMatch($event, stats)" *ngIf="stats.index != isHoveredMatch" >{{stats.MatchWin}} - {{stats.MatchTot - stats.MatchWin}}</p>
           <p   (mouseleave)="isNotHoverMatch($event, stats)" *ngIf="isHoveredMatch == stats.index" >{{stats.MatchWinPercentage.toFixed(0)}} %</p>
         </div>
         <ng-template #percent>
           <div [ngClass]="{'uppertext-black':isMaxValue(data, 'match') === stats.MatchWinPercentage, 'uppertext':isMaxValue(data, 'match') !== stats.MatchWinPercentage}" isHovered>
               <p (mouseleave)="isNotHoverMatch($event, stats)" *ngIf="isHoveredMatch == stats.index" >{{stats.MatchWin}} - {{stats.MatchTot - stats.MatchWin}}</p>
               <p  (mouseenter)="isHoverMatch($event, stats)" *ngIf="stats.index != isHoveredMatch" >{{stats.MatchWinPercentage.toFixed(0)}} %</p>
           </div>

         </ng-template>
          </ng-template>
</ng-container>
     <ng-template #zero>

      <div [ngClass]="{'uppertext-black':isMaxValue(data, 'tier') === stats.TBWinPercentage, 'uppertext':isMaxValue(data, 'tier') !== stats.TBWinPercentage}" isHovered >
        <p  (mouseenter)="isHoverTier($event, stats)" *ngIf="stats.index != isHoveredTier" >-</p>
        <p  (mouseleave)="isNotHoverTier($event, stats)" *ngIf="stats.index == isHoveredTier" >-</p>
      </div>
      </ng-template>
      </div>

<div class="uppertext-no-viewport">
  {{'Qualification_Best' | transloco}}
  <p [ngClass]="{'uppertext-black':isMaxValue(data, 'qbest') === stats.QBest, 'uppertext':isMaxValue(data, 'qbest') !== stats.QBest}" *ngIf="stats.QBest != null; else zero" class="uppertext-black center-text">
      {{' '}}{{stats.QBest}}
    </p>
    <ng-template #zero>
      <div class="uppertext" >-</div>
    </ng-template>

</div>

</ng-template>



  </app-wa-table>
</div>
